import apiEndpoints from '../../../apiEndpoints';
import { fetcher } from '../../utils/fetchers/fetcher';

export const requestFilter = (
  filterId: string,
  token: string | null,
  forceHeader?: string
  //TODO: Create return type
): Promise<any> =>
  fetcher<any>(
    `${apiEndpoints.routes.filters}/${filterId}`,
    'GET',
    token,
    forceHeader
  );
